import { type FunctionComponent, type MouseEvent, useContext, useEffect, useState } from 'react';
import { QuickStartContext } from '../../contexts/quickstart/quickstart.context';
import { buildGTMSblFavoriteLook } from '../../helpers/analytics/gtm/event-builders';
import { useTrackEvent } from '../../hooks/analytics/analytics.hooks';
import { useReactToQuickStart } from '../../hooks/project/project.hooks';
import { QuickStartFavoriteButton } from '../quick-start-favorite-button/quick-start-favorite-button.component';

export type QuickStartReactionButtonProps = {
	onClick?: (e: MouseEvent<HTMLElement>) => void;
	quickStartId: number;
	isShopByLook?: boolean;
};

export const QuickStartReactionButton: FunctionComponent<QuickStartReactionButtonProps> = ({ onClick, quickStartId, isShopByLook }) => {
	const [isLiked, setIsLiked] = useState(false);
	const { favoritedQuickStarts } = useContext(QuickStartContext);
	const reactToQuickStart = useReactToQuickStart();
	const trackEvent = useTrackEvent();

	useEffect(() => {
		setIsLiked(favoritedQuickStarts.includes(quickStartId));
	}, [quickStartId, favoritedQuickStarts, setIsLiked]);

	const handleClick = (e: MouseEvent<HTMLElement>): void => {
		reactToQuickStart(quickStartId);
		e.preventDefault();
		e.stopPropagation();
		if (onClick) {
			onClick(e);
		}
		if (isShopByLook) {
			trackEvent(buildGTMSblFavoriteLook());
		}
	};
	return <QuickStartFavoriteButton handleClick={handleClick} isSelected={isLiked} />;
};
